import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Please choose a new password for {email}',
  password: 'Password',
  confirmPassword: 'Confirm password',
  passwordRequired: 'Please enter your password.',
  confirmRequired: 'Please confirm your password.',
  passwordMissmatch: 'The two passwords do not match.',
  submit: 'Set new password',
  updatePasswordFailed: 'Failed to set new password, please try again later.',
  errorPasswordTooCommon: 'Password is too common',

  invalidLinkTitle: 'This link is no longer valid',
  invalidLinkDesc: 'If you want to reset your password you have to generate a new link.',
  generateLink: 'Generate link',
});
